import React from 'react'
import Badge from 'react-bootstrap/Badge'
import Button from 'react-bootstrap/Button'
import AppTa from '../AppTa'

class About extends React.PureComponent {
  render() {
    return (
      <div>

        <p>
          SV About Component
        </p>
        <AppTa></AppTa>
        <div className="mb-2">
          <Button variant="primary" size="lg">
            Large button
          </Button>{' '}
          <Button variant="secondary" size="lg">
            Large button
          </Button>
      </div>
     <h1>
        Example heading
        <Badge bg="secondary" as={Button}>
          New
        </Badge>
      </h1>
        
      </div>
    )
  }
}

export default About
